// extracted by mini-css-extract-plugin
export default {"PopOut":"Badge_PopOut__yYzJD","Badge":"Badge_Badge__h9egz"};